<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBandの天気情報は現在の天気と異なる原因'">
      <template slot="content">
        <div class="text">
          WeRUNアプリは利用者の現在地を元に将来数日分の天気予報データを取得し、WeBandとデータ同期を行うたびにWeBandに天気情報を送信しています。<br>
          場所を移動してからアプリを開いていなかったり、アプリを開いたときにGPS信号が弱かったり等の原因によって、過去に取得した天気情報が表示されることがあります。<br><br>
          <b>定期的にアプリを開く</b>ことによって、新しい現在地の天気予報データが取得できるため、天気情報の精度が高くなります。<br>
          なお、天気情報を取得するために現在地の情報が必要のため、位置情報の権限を許可してください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H9_2.png">
        <img class="picture" src="../assets/images/q_and_a/H21.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help20.vue